export enum ConnectionStatusCategoryEnum {
  COMPLETED = 'completed',
  IN_PROCESS = 'in_process',
  PENDING_RESPONSE = 'pending_response',
  REJECTED = 'rejected',
  DENIED = 'denied',
  ALL = 'all',
}
